import React from 'react'
import cx from 'classnames'
import injectGlobals from 'local_modules/injectGlobals'

import Link from 'components/ui/Link/Link'

import s from './Logo.scss'


const Logo = ({ city, logo, host, isMobile }) => {
  const trueCity = (city !== 'sarov' || !(host || '').includes(city)) ? null : city
  const isLogoBg = !trueCity && !isMobile

  return (
    <Link
      className={cx(s.logo, {
        [s[city]]: trueCity
      })}
      style={isLogoBg ? { backgroundImage: `url(${logo})` } : {}}
      toOLD="/"
    />
  )
}


export default injectGlobals(({ globals }) => ({
  isMobile: globals.isMobile,
  host: globals.host,
}))(Logo)
